import React from "react";
import "./itikaf.scss";
import { PhotoColumn } from "../../components/photo-column";
import aliUlviKurucu from '../../assets/photos/portraits/ali-ulvi-kurucu.jpg';
import abdullahQari from '../../assets/photos/portraits/abdullah-qari_2.jpg';
import abdullahQari2 from '../../assets/photos/portraits/abdullah-qari_3_600.jpg';
import hirkaiSerifCamii from '../../assets/photos/itikaf/hirka-i_serif_cami.jpg';
import beyazitCamii from '../../assets/photos/itikaf/beyazit-camii.jpg';
import babaKabe from '../../assets/photos/itikaf/baba-kabe.jpeg';
import babaMedine from '../../assets/photos/itikaf/baba-medine.jpg';
import hirkaiSerif from '../../assets/photos/itikaf/hirka-i-serif.png';
import hirkaiSerifBaba1 from '../../assets/photos/itikaf/hirka-i-serif-baba-1.png';
import hirkaiSerifBaba2 from '../../assets/photos/itikaf/hirka-i-serif-baba-2.jpg';
import abdullahKari2 from '../../assets/photos/itikaf/abdullah-kari-baba.jpg';
import kirmizi1 from '../../assets/photos/itikaf/baba-beyazit-cami.jpg'
import itikafOdasi from '../../assets/photos/itikaf/itikaf-odasi.jpg';
import babaCennetBahcesi from '../../assets/photos/itikaf/baba-cennet-bahcesi-515.jpg';
import icazetMerasimi from '../../assets/photos/itikaf/icazet-merasimi-464.jpg';
import babaKabeItikaf from '../../assets/photos/itikaf/baba-kabe-itikaf.jpg';
import bilaliHabesiCami from '../../assets/photos/itikaf/bilali-habesi-cami-475.jpg';
import ebuKubeys from '../../assets/photos/itikaf/ebu-kubeys.jpg';
import ahmetTahir from '../../assets/photos/itikaf/ahmet-tahir.jpg';
import ihsanSanabel from '../../assets/photos/itikaf/ihsan-sanabel-515.jpg';
import muhammedSiddik1 from '../../assets/photos/itikaf/muhammed-siddik-meymeni-1-445.jpg';
import muhammedSiddik2 from '../../assets/photos/itikaf/muhammed-siddik-meymeni-2-445.jpg';
import fatihCamii from '../../assets/photos/itikaf/fatih-cami-ici.jpg';
import hzPireNiyaz from '../../assets/photos/itikaf/hz-pire-niyaz.jpg';
import abdullahKariGenc from '../../assets/photos/itikaf/abdullah-kari-genc.jpg';
import mekkeKapisi from '../../assets/photos/itikaf/mekke-kapisi-rahle.jpg';
import hicazHavaYollari from '../../assets/photos/hacc/hicaz-yollari.jpg';
import mikatMahali from '../../assets/photos/hacc/mikat-mahalli.jpg';
import kabe from '../../assets/photos/hacc/eski-kabe.jpg';
import kabePanorama from '../../assets/photos/hacc/kabe-panorama.jpg';
import tavafBaslangicNoktasi from '../../assets/photos/hacc/tavaf-baslangic-noktasi.jpg';
import kabeSaftlar from '../../assets/photos/hacc/kabe-savt.jpg';
import kitabe from '../../assets/photos/hacc/kitabe.jpg';
import makamiIbrahimAll from '../../assets/photos/hacc/makami-ibrahim-all.jpg';
import hacerulEsved from '../../assets/photos/hacc/hacerul-esved.jpg';
import safaTepesi from '../../assets/photos/hacc/safa-tepesi.jpg';
import merveTepesi from '../../assets/photos/hacc/merve-tepesi.jpg';
import ilkZemzemKuyusu from '../../assets/photos/hacc/ilk-zemzem-kuyusu.jpg';
import multezemKapisi from '../../assets/photos/hacc/multezem-kapisi.jpg';
import hudeybiye01 from '../../assets/photos/itikaf/hudeybiye01.jpg';
import hudeybiyeKuyusu from '../../assets/photos/itikaf/hudeybiye-kuyusu.jpg';
import haremSinir from '../../assets/photos/itikaf/harem-siniri.jpg';
import kabeKapilari from '../../assets/photos/itikaf/kabe-kapilari.jpg';
import cennetiMualla from '../../assets/photos/itikaf/cennetul-mualla.jpg';
import cebeliNur from '../../assets/photos/itikaf/cebeli-nur.jpg';
import sevrDagi from '../../assets/photos/itikaf/sevr-dagi.jpg';
import sevrMagarasi from '../../assets/photos/itikaf/sevr-magarasi.jpg';

interface AboutAssociationProps {

}
interface AboutAssociationState {
    Change: boolean;
}


class Itikaf extends React.Component<AboutAssociationProps, AboutAssociationState> {
    constructor(props: any) {
        super(props);
        this.state = {
            Change: true
        };
    }
    render() {
        return (
            <section className="itikaf-section">
                <h3 className="section-title">İTİKAF HATIRALARIMIZ</h3>

                <article>
                    <p>
                        1984 senesinde Ramazan-ı Şerif ayında Hicri yıl ile 20 Ramazan 1404 yılında ilk itikafımız nasip oldu.
                    </p>
                    <p>
                        Muzaffer Efendi'nin itikafa girmemi önermesiyle ilk itikafıma başladım. O zamanlar dergâhtan Sabri Bey Can Feda Camii'nde itikafa girdi.
                    </p>

                    <div>
                        <PhotoColumn
                            imageSource={hzPireNiyaz}
                            imageTitle="Kâbe-i Muazzama"
                            figcaptionFirstTitle="Hz. Pir'den İlk İtikafımız İçin Destur Alırken"
                            className="red-caption"
                        />

                    </div>

                    <div>
                        <h3 className="itikaf-section__title">Hırka-i Şerif Camii'ndeki İlk İtikafımız</h3>
                        <p>
                            Biz de Peygamberimiz Muhammed Mustafa(S.A.V)’in Mirac-ı Muhammediyeyi gerçekleştirirken üzerinde bulunan hırkanın sergilendiği Hırka-i Şerif Dairesinin yanındaki muhaffız odasında itikafa girdik. Çok aşklı ve şevkli bir itikaf idi. İtikaf, akıl üstü bir olaydır. Akıl ile izahı mümkün değildir.
                        </p>

                        <PhotoColumn
                            imageSource={hirkaiSerifCamii}
                            imageTitle="Hırka-i Şerif Camii"
                            figcaptionFirstTitle="Hırka-i Şerif Camii"
                            className="red-caption"
                        />
                        <PhotoColumn
                            imageSource={hirkaiSerif}
                            imageTitle="Hırka-i Şerif Camii"
                            figcaptionFirstTitle="Hırka-i Şerif'in Korunduğu Bölüm"
                            className="red-caption"
                        />

                        <div className="photo-column__content">
                            <PhotoColumn
                                imageSource={hirkaiSerifBaba1}
                                imageTitle="Hırka-i Şerif Camii"
                                figcaptionFirstTitle="Hırka-i Şerif Camii"
                                className="red-caption"
                            />
                            <PhotoColumn
                                imageSource={hirkaiSerifBaba2}
                                imageTitle="Hırka-i Şerif Camii"
                                figcaptionFirstTitle="Hırka-i Şerif Camii"
                                className="red-caption"
                            />

                        </div>
                    </div>

                    <div>
                        <h3 className="itikaf-section__title">Beyazıt Camii'ndeki İkinci İtikafımız</h3>
                        <p className="itikaf-year">Miladi: 25 Nisan 1989/ Hicri: 19 Ramazan 1409 Yılında </p>
                        <PhotoColumn
                            imageSource={beyazitCamii}
                            imageTitle="Beyazıt Camii"
                            figcaptionFirstTitle="Beyazıt Camii"
                            className="red-caption"
                        />

                        <div className="photo-column__content">
                            <PhotoColumn
                                imageSource={kirmizi1}
                                imageTitle="Beyazıt Camii"
                                figcaptionFirstTitle="Beyazıt Camii"
                                className="red-caption"
                            />

                            <PhotoColumn
                                imageSource={itikafOdasi}
                                imageTitle="Beyazıt Camii"
                                figcaptionFirstTitle="İtikaf Odası"
                                className="red-caption"
                            />
                        </div>

                        <p>
                            1989 senesinde İstanbul'da İtikaf merkezi olarak bilinen Beyazıt Caminde, Beyazıt-ı Veli Hazretlerinin huzurunda Makam-ı İtikaf'ta ikinci itikafta bulunduk.
                        </p>
                        <p>
                            Sefer Efendi ve Çelebi Necdet Efendi Beyazıt camiinde itikafa girmemi önermişti.
                        </p>
                    </div>


                    <p>
                        Tekrar başka bir tarihte müteakiben Medine-i Münevvere'de itikafa girdik. Hava alanında mana zuhur etti. Dediler ki sen bundan sonra Mekke'de itikafa gireceksin.
                        Abdülaziz merdivenlerinde Hz Pir beni çıkarıyordu.. Hacerül Esvedin karşısında 2. katta  -Türklerin ekseriyetle bulunduğu- yeşil ışığa yakın bir yerde Umreye gireceğimi buyurdular.
                        Bu tarihten sonra hep aynı yerde itikafa girdik.
                    </p>

                    <p>
                        Bu itikaflarımızda devamlı surette Seyyid Abdullah Kâri ile beraber itikafta bulunduk.
                        Pandemiye kadar 19 sene boyunca beraber itikaf yaptık.
                    </p>

                    <h3 className="itikaf-section__title">Medine-i Münevvere'deki İtikaflarımız</h3>
                    <p className="itikaf-year">Miladi: 6 Mart 1992/ Hicri: 19 Ramazan 1412 Yılında </p>
                    <p>
                        1992 senesinde Ramazan-ı Şerif ayında Üçüncü itikafımız Medine-i Münevvere’de yapmak nasip oldu.
                    </p>
                    <div>

                        <div className="medine-section__content">

                            <PhotoColumn
                                imageSource={babaMedine}
                                imageTitle="Medine-i Münevvere"
                                figcaptionFirstTitle="Medine-i Münevvere"
                                className="red-caption"
                            />

                            <div className="paragraph__content">
                                <p>
                                    Bu itikaflarda Ravza-i Mutahhara'da toplantılar düzenlenirdi. Çeşitli ülkelerden gelen meşayihle çok önemli görüşmeler yapılırdı.
                                    Bu değerli toplantılarda maddi ve manevi meseleler, dünya ve ahiret hakkında çok feyizli ve bereketli sohbetler gerçekleşirdi.
                                    Bu itikaflarımızda Allah (C.C) bir gecede 40 veli ile görüşme imkânı nasip etti.
                                </p>

                                <p>
                                    Medine-i Münevvere'de Ali Ulvi Kurucu, Dr Ali Kemal Belviranlı ve
                                    biraderi bunun dışında hariciye diplomatları da vardı. Ali Kemal bey musikişinas bir doktor idi.
                                    Mekke-i Mükerreme'de gerçekleşen bir toplantı da ise Kâbe müdürü Muhammed Yusuf da bulundu.
                                </p>

                                <p>
                                    Bu itikaflarda Kadir gecesini birkaç sefer idrak etmek nasip oldu. Allah'a şükürler olsun. Allah cümlemize nasip etsin öyle bir kadir gecesini yaşamayı..
                                </p>

                            </div>
                        </div>

                        <div className="photo-column__content">
                            <PhotoColumn
                                imageSource={bilaliHabesiCami}
                                imageTitle="Medine-i Münevvere"
                                figcaptionFirstTitle="Bilal-i Habeşi Camii"
                                className="red-caption"
                            />

                            <PhotoColumn
                                imageSource={icazetMerasimi}
                                imageTitle="Medine-i Münevvere"
                                figcaptionFirstTitle="Bilal-i Habeşi Camii'sinde İcazet Merasimi"
                                className="red-caption"
                            />
                        </div>

                        <div className="photo-column__content">
                            <PhotoColumn
                                imageSource={muhammedSiddik1}
                                imageTitle="Muhammed Sıddık el-Meymeni"
                                figcaptionFirstTitle="Muhammed Sıddık el-Meymeni ile çekilen bir fotoğraf"
                                className="red-caption"
                            />
                            <PhotoColumn
                                imageSource={muhammedSiddik2}
                                imageTitle="Muhammed Sıddık el-Meymeni"
                                figcaptionFirstTitle="Muhammed Sıddık el-Meymeni"
                                className="red-caption"
                            />
                        </div>
                        <div className="medine-section__content">
                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }} className="cennet-bahcesi">
                                <PhotoColumn
                                    imageSource={babaCennetBahcesi}
                                    imageTitle="Medine-i Münevvere"
                                    figcaptionFirstTitle="Medine-i Münevvere'deki Cennet Bahçesi"
                                    className="red-caption"
                                />
                                <PhotoColumn
                                    imageSource={ihsanSanabel}
                                    imageTitle="Medine-i Münevvere İhsan Sanabel"
                                    figcaptionFirstTitle="Yakub Baba'nın değerli dostu, Sanabel otelin sahibi İhsan Sanabel ile sohbet ederken"
                                    className="red-caption"
                                />
                            </div>
                            <div>
                                <PhotoColumn
                                    imageSource={aliUlviKurucu}
                                    imageTitle="Ali Ulvi Kurucu"
                                    figcaptionFirstTitle="Ali Ulvi Kurucu"
                                    className="red-caption"
                                />
                            </div>
                        </div>
                    </div>

                    <h3 className="itikaf-section__title">Kâbe-i Muazzama'daki İtikaflarımız</h3>

                    <div>
                        <p className="itikaf-subtitle">Mekke-i Mükerreme'deki 4. İtikafımız</p>
                        <p className="itikaf-year">Miladi: 14 Mart 1993/ Hicri: 20 Ramazan 1413 Yılında </p>
                        <PhotoColumn
                            imageSource={mekkeKapisi}
                            imageTitle="Kâbe-i Muazzama"
                            figcaptionFirstTitle="Mekke-i Mükerreme Kapısı"
                            className="red-caption"
                        />

                    </div>

                    <p>
                        1996 senesinde Ramazan-ı Şerif ayında dördüncü itikafımız Mekke-i Mükerreme’de yapmak nasip oldu.
                    </p>
                    <p>
                        Medine-i Münevverede itikaf niyeti ile gittik.. Oraya vardık. Medine-i Münevverede iken mana zuhur etti. Manada Hz. Pir Nureddin Cerrahi bizi Abdülaziz Kapısının yanındaki merdivenlerinde çıkarıyordu. Hacerül Esvedin karşısında 1. Katta yeşil ışığa yakın bir yerde İtikafa gireceğimi buyurdular. Bu tarihten sonra hep aynı yerde itikafa girdik.
                    </p>
                    <p>
                        Bu itikaflarımızda devamlı surette Seyyid Abdullah Kâri ile beraber itikafta bulunurduk.. Kâri soyundan gelenler hep hafızlar olarak yetiştirilir.
                    </p>



                    <div>
                        <p className="itikaf-subtitle">Mekke-i Mükerreme'deki 5. İtikafımız</p>
                        <p className="itikaf-year">Miladi: 3 Mart 1994/ Hicri: 20 Ramazan 1414 Yılında </p>
                        <PhotoColumn
                            imageSource={babaKabeItikaf}
                            imageTitle="Kâbe-i Muazzama"
                        />
                    </div>


                    <div>
                        <p className="itikaf-subtitle">Mekke-i Mükerreme'deki 6. İtikafımız</p>
                        <p className="itikaf-year">Miladi: 20 Şubat 1995/ Hicri: 20 Ramazan 1415 Yılında </p>
                        <PhotoColumn
                            imageSource={hicazHavaYollari}
                            imageTitle="Kâbe-i Muzzama"
                        />
                    </div>

                    <div>
                        <p className="itikaf-subtitle">Mekke-i Mükerreme'deki 7. İtikafımız</p>
                        <p className="itikaf-year">Miladi: 9 Şubat 1996/ Hicri: 20 Ramazan 1416 Yılında </p>
                        <PhotoColumn
                            imageSource={hudeybiye01}
                            imageTitle="Hudeybiye"
                            isTextOverImage={true}
                            imageOverlyTextFirst="Muhakkak ki sana biat edenler ancak Allah’a biat etmektedirler. Allah’ın eli onların ellerinin üzerindedir. Kim ahdini bozarsa ancak kendi aleyhine bozmuş olur. Kim de Allah ile olan ahdine vefa gösterirse Allah ona büyük bir mükafat verecektir. (Fetih, 10)"
                            imageOverlyTextSecond="Fetih suresi 18. Âyetin İşaret ettiği biat, Hudeybiye’de “Semre” ağacının  altında yapılan “Rıdvan biatı”dır. 1400 sahâbi, Kureyş’e karşı ölünceye kadar savaşacaklarına  yemin etmişlerdi. Haber verilen yakın fetih, Hayber’in fethi olarak anlaşılmıştır."
                        />
                        <PhotoColumn
                            imageSource={hudeybiyeKuyusu}
                            imageTitle="Hudeybiye Kuyusu"
                            figcaptionFirstTitle={"Hudeybiye Kuyusu"}
                            className="red-caption"
                        />
                        <PhotoColumn
                            imageSource={haremSinir}
                            imageTitle="Hudeybiye"
                            figcaptionFirstTitle={"Harem sınırlarını gösteren işaretler ve harem sınırı."}
                            className="red-caption"
                        />
                    </div>

                    <div>
                        <p className="itikaf-subtitle">Mekke-i Mükerreme'deki 8. İtikafımız</p>
                        <p className="itikaf-year">Miladi: 29 Ocak 1997/ Hicri: 20 Ramazan 1417 Yılında </p>
                        <PhotoColumn
                            imageSource={mikatMahali}
                            imageTitle="Mikat Mahali"
                            figcaptionFirstTitle="Mikat Mahali"
                            className="red-caption"
                        />
                    </div>

                    <div>
                        <p className="itikaf-subtitle">Mekke-i Mükerreme'deki 9. İtikafımız</p>
                        <p className="itikaf-year">Miladi: 19 Ocak 1998/ Hicri: 20 Ramazan 1418 Yılında </p>
                        <PhotoColumn
                            imageSource={kabe}
                            imageTitle="Kâbe-i Muazzama"
                            figcaptionFirstTitle="Kâbe-i Muazzama"
                            className="red-caption"
                        />
                    </div>
                    <div>
                        <p className="itikaf-subtitle">Mekke-i Mükerreme'deki 10. İtikafımız</p>
                        <p className="itikaf-year">Miladi: 8 Ocak 1999/ Hicri: 20 Ramazan 1419 Yılında </p>
                        <PhotoColumn
                            imageSource={kabePanorama}
                            imageTitle="Kâbe-i Muzzama"
                        />
                    </div>
                    <div>
                        <p className="itikaf-subtitle">Mekke-i Mükerreme'deki 11. İtikafımız</p>
                        <p className="itikaf-year">Miladi: 28 Aralık 1999/ Hicri: 20 Ramazan 1420 Yılında </p>
                        <PhotoColumn
                            imageSource={tavafBaslangicNoktasi}
                            imageTitle="Tavaf Başlangıç Noktası"
                        />
                    </div>
                    <div>
                        <p className="itikaf-subtitle">Mekke-i Mükerreme'deki 12. İtikafımız</p>
                        <p className="itikaf-year">Miladi: 16 Aralık 2000/ Hicri: 20 Ramazan 1421 Yılında </p>
                        <PhotoColumn
                            imageSource={kabeSaftlar}
                            imageTitle="Kâbe Şavtlar"
                            figcaptionFirstTitle="Kâbe’nin tavafında yedi şavtın uygulanışını gösteren şema."
                            className="red-caption"
                        />
                    </div>

                    <div>
                        <p className="itikaf-subtitle">Mekke-i Mükerreme'deki 13. İtikafımız</p>
                        <p className="itikaf-year">Miladi: 5 Aralık 2001/ Hicri: 20 Ramazan 1422 Yılında </p>
                        <PhotoColumn
                            imageSource={makamiIbrahimAll}
                            imageTitle=""
                        />
                        <div className="makami-ibrahim">
                            <PhotoColumn
                                imageSource={kitabe}
                                imageTitle="Makam-ı İbrahim"
                                figcaptionFirstTitle="Hz. İbrahim (A.S.)’ın Kâbbe’nin bina edilişi sırasında bastığı taş ve üzerindeki ayak izleri (Makam-ı İbrahim)."
                                figcaptionColor="#e30b17"
                                figcaptonFontWeight={"bold"}
                            />
                        </div>
                    </div>

                    <div>
                        <p className="itikaf-subtitle">Mekke-i Mükerreme'deki 14. İtikafımız</p>
                        <p className="itikaf-year">Miladi: 25 Kasım 2002 / Hicri: 20 Ramazan 1423 Yılında </p>
                        <PhotoColumn
                            imageSource={hacerulEsved}
                            imageTitle="Hacer'ül Esved"
                            figcaptionFirstTitle="Hacer'ül Esved"
                            className="red-caption"
                        />
                    </div>
                    <div>
                        <p className="itikaf-subtitle">Mekke-i Mükerreme'deki 15. İtikafımız</p>
                        <p className="itikaf-year">Miladi: 15 Kasım 2003 / Hicri: 20 Ramazan 1424 Yılında </p>
                        <PhotoColumn
                            imageSource={multezemKapisi}
                            imageTitle="Kâbe-i Muazzama Mültezem Kapısı"
                            figcaptionFirstTitle="Kâbe-i Muazzama Mültezem Kapısı"
                            className="red-caption"
                        />
                    </div>
                    <div>
                        <p className="itikaf-subtitle">Mekke-i Mükerreme'deki 16. İtikafımız</p>
                        <p className="itikaf-year">Miladi: 3 Kasım 2004 / Hicri: 20 Ramazan 1425 Yılında </p>
                        <PhotoColumn
                            imageSource={safaTepesi}
                            imageTitle=""
                            figcaptionFirstTitle="Şüphesiz Safâ ve Merve, Allah’ın sembollerindendir.(Bakara, 158)"
                            figcaptionSecondTitle="Say’in başlandığı yer, Safa tepesi."
                            className="red-caption"
                        />
                    </div>
                    <div>
                        <p className="itikaf-subtitle">Mekke-i Mükerreme'deki 17. İtikafımız</p>
                        <p className="itikaf-year">Miladi: 24 Ekim 2005 / Hicri: 20 Ramazan 1426 Yılında </p>
                        <PhotoColumn
                            imageSource={merveTepesi}
                            imageTitle=""
                            figcaptionFirstTitle="Şüphesiz Safâ ve Menve, Allah’ın sembollerindendir. (Bakara, 158)"
                            figcaptionSecondTitle="Say’in bittiği yer, Merve Tepesi."
                            className="red-caption"
                        />
                    </div>
                    <div>
                        <p className="itikaf-subtitle">Mekke-i Mükerreme'deki 18. İtikafımız</p>
                        <p className="itikaf-year">Miladi: 13 Ekim 2006 / Hicri: 20 Ramazan 1427 Yılında </p>
                        <PhotoColumn
                            imageSource={ilkZemzemKuyusu}
                            imageTitle="Zemzem Kuyusu"
                            figcaptionFirstTitle="Hz. Hacer’e ikram olunan zemzemin ilk zuhurunu temsil eden resim."
                            className="red-caption"
                        />
                    </div>

                    <div>
                        <p className="itikaf-subtitle">Mekke-i Mükerreme'deki 19. İtikafımız</p>
                        <p className="itikaf-year">Miladi: 2 Ekim 2007 / Hicri: 20 Ramazan 1428 Yılında </p>
                        <PhotoColumn
                            imageSource={kabeKapilari}
                            imageTitle="Kâbe-i Muzzama"
                            figcaptionFirstTitle="Kâbe'nin planını gösteren bir çizim"
                            className="red-caption"
                        />
                    </div>
                    <div>
                        <p className="itikaf-subtitle">Mekke-i Mükerreme'deki 20. İtikafımız</p>
                        <p className="itikaf-year">Miladi: 20 Eylül 2008/ Hicri: 20 Ramazan 1429 Yılında </p>
                        <PhotoColumn
                            imageSource={cennetiMualla}
                            imageTitle="Cennetü’l–Mualla"
                            figcaptionFirstTitle="Cennetü’l–Mualla’da göçmen kuşlar için yapılan barınaklar"
                            className="red-caption"
                        />
                    </div>

                    <div>
                        <p className="itikaf-subtitle">Mekke-i Mükerreme'deki 21. İtikafımız</p>
                        <p className="itikaf-year">Miladi: 9 Eylül 2009 / Hicri: 20 Ramazan 1430 Yılında </p>
                        <PhotoColumn
                            imageSource={abdullahKariGenc}
                            imageTitle="Kâbe-i Muzzama"

                        />
                    </div>

                    <div>
                        <p className="itikaf-subtitle">Mekke-i Mükerreme'deki 22. İtikafımız</p>
                        <p className="itikaf-year">Miladi: 30 Ağustos 2010 / Hicri: 20 Ramazan 1431 Yılında </p>
                        <p>
                            Yakub Baba'nın itikaf reisi seçildiği "Tac Giydirme Merasimi". Bu merasimde Yakub Baba kırk veli ile görüşür.
                            Sudanlı Ahmed Tahir Efendi tarafından kırk arşın boyundaki Sudan Tacı giydirilir.
                        </p>
                        <PhotoColumn
                            imageSource={ahmetTahir}
                            imageTitle="Kâbe-i Muzzama"
                            figcaptionFirstTitle={"Tac Giydirme Merasimi"}
                            figcaptionSecondTitle="(Ahmed Tahir Efendi En Sağda)"
                            className="red-caption"
                        />
                    </div>

                    <div>
                        <p className="itikaf-subtitle">Mekke-i Mükerreme'deki 23. İtikafımız</p>
                        <p className="itikaf-year">Miladi: 20 Ağustos 2011/ Hicri: 20 Ramazan 1432 Yılında </p>
                        <PhotoColumn
                            imageSource={abdullahKari2}
                            imageTitle="Kâbe-i Muzzama"
                        />
                    </div>

                    <div>
                        <p className="itikaf-subtitle">Mekke-i Mükerreme'deki 24. İtikafımız</p>
                        <p className="itikaf-year">Miladi: 8 Ağustos 2012/ Hicri: 20 Ramazan 1433 Yılında </p>
                        <div className="photo-column">
                            <figure>
                                <img src={abdullahQari2} alt="İtikaf" />
                            </figure>
                            <figure>
                                <img src={abdullahQari} alt="İtikaf" />
                            </figure>
                        </div>
                    </div>

                    <div>
                        <p className="itikaf-subtitle">Mekke-i Mükerreme'deki 25. İtikafımız</p>
                        <p className="itikaf-year">Miladi: 28 Temmuz 2013/ Hicri: 20 Ramazan 1434 Yılında </p>
                        <PhotoColumn
                            imageSource={cebeliNur}
                            imageTitle="Cebel-i Nur"
                            figcaptionFirstTitle="Cebel-i Nur"
                            className="red-caption"
                        />
                    </div>

                    <div>
                        <p className="itikaf-subtitle">Mekke-i Mükerreme'deki 26. İtikafımız</p>
                        <p className="itikaf-year">Miladi: 17 Temmuz 2014 / Hicri: 20 Ramazan 1435 Yılında </p>
                        <PhotoColumn
                            imageSource={sevrMagarasi}
                            imageTitle="Sevr Mağarası"
                            figcaptionFirstTitle="Sevr Mağarası"
                            className="red-caption"
                        />
                        <PhotoColumn
                            imageSource={sevrDagi}
                            imageTitle="Sevr Dağı"
                            figcaptionFirstTitle='"Hani o mağarada iken arkadaşına: ‘Üzülme Allah bizimle beraberdir!’ diyordu.” (Tevbe, 40) Sevr Dağı ve Mağarası'
                            className="red-caption"
                        />

                    </div>

                    <div>
                        <p className="itikaf-subtitle">Mekke-i Mükerreme'deki 27. İtikafımız</p>
                        <p className="itikaf-year">Miladi: 7 Temmuz 2015 / Hicri: 20 Ramazan 1436 Yılında </p>
                        <PhotoColumn
                            imageSource={fatihCamii}
                            imageTitle="Kâbe-i Muzzama"
                        />
                    </div>

                    <div>
                        <p className="itikaf-subtitle" style={{ color: "#008000" }}>Mekke-i Mükerreme'deki 28. İtikafımız</p>
                        <p className="itikaf-year">Miladi: 25 Haziran 2016 / Hicri: 20 Ramazan 1437 Yılında </p>
                        <PhotoColumn
                            imageSource={babaKabe}
                            imageTitle="Kâbe-i Muzzama"
                        />
                    </div>

                    <div style={{ display: "none" }}>
                        <p className="itikaf-year">Miladi: 15 Haziran 2017 / Hicri: 20 Ramazan 1438 Yılında </p>
                        <p className="itikaf-year">Miladi: 4 Haziran 2018  Hicri: 20 Ramazan 1439 Yılında </p>
                        <p className="itikaf-year">Miladi: 25 Mayıs 2019 Hicri: 20 Ramazan 1440 Yılında </p>

                    </div>

                    <div style={{ marginTop: 20 }}>
                        <h3 className="sub-title">
                            Efendimizin (S.A.V), Ebu Kubeys tepesinde<br />
                            Taif dönüşü mübarek gözü yaşlı olarak
                            yapmış olduğu o müthiş dua:
                        </h3>

                        <div className="verse-content">
                            <PhotoColumn
                                imageSource={ebuKubeys}
                                imageTitle="Ebu Kubeys Dağı"
                                figcaptionFirstTitle=""
                            />

                            <p className="verse">
                                Allah’ım!<br />
                                Kuvvetimin tükendiğini Sana arz ediyorum.<br />
                                Gücümün azaldığını,<br />
                                İnsanların gözünde küçük düştüğümü Sana şikayet ediyorum!<br />
                                Ya Erhamerrahimin!<br />
                                Sensin ezilmişlerin Rabbi!<br />
                                Sensin benim Rabbim!<br />
                                Beni kimlerin eline bıraktın?<br />
                                Bana gaddarlık yapan yabancıların eline mi?<br />
                                Yoksa, davamı ipotek edecek bir düşmana mı?<br />
                                Eğer sen bana gücenmedinse,<br />
                                kesinlikle bunlara aldırmıyorum.<br />
                                Lakin iyiliğin beni rahatlatacaktır.<br />
                                Senin nuruna sığınırım;<br />
                                karanlıkları aydınlatan nuruna,<br />
                                dünya ve ahiretimi aydınlatacak nuruna…<br />
                                Gelecek gazabın, bana ulaşacak öfkenden<br />
                                kaçıp kurtulacak bir sığınak arıyorum.<br />
                                Sana sığındım, yeter ki razı ol!<br />
                                Güç ve kuvvet Sendendir,<br />
                                yalnız Senden!”<br />
                                Allah’ım!<br />
                            </p>
                        </div>

                        <p style={{ textIndent: 0 }}>
                            Zaman zaman itikaf yaparken bu duayı okuyorduk. Bizi çok hüzünlendiriyordu.
                        </p>
                    </div>
                </article>
            </section>

        );
    }
}

export default Itikaf;